import { render, staticRenderFns } from "./GastroPosizionamentoBibEdit.vue?vue&type=template&id=b9a6bb5a"
import script from "./GastroPosizionamentoBibEdit.vue?vue&type=script&lang=js"
export * from "./GastroPosizionamentoBibEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports